// Shared role-label helper. Centralises display strings for user_organisations
// roles so the wording stays consistent across screens. Used by:
//   - Logins create/edit modal
//   - Organisation > Delegated Approval section
//   - Pending Approvals page (submitter label)
//   - Sidebar profile chip
//   - any future surface that shows access role to admins/owners
//
// `centre_director` always renders as "Centre Director" regardless of the
// org's approval-workflow flag — this is a permanent role, not a relabelling
// of support. `support` reverts to displaying "Support" (the original PR
// briefly relabelled support→"Location Director" when the workflow flag was
// on; that overload was reverted in Phase 2 when centre_director was added).
export const labelForRole = (role) => {
  if (!role) return '';
  if (role === 'centre_director') return 'Centre Director';
  if (role === 'co_only') return 'Co Only';
  return role.charAt(0).toUpperCase() + role.slice(1);
};
